<template lang="pug">
  div
    .subheading Acesso ao portal
    v-form(@submit.prevent='onSubmit')
      v-text-field(v-model='model.email' light prepend-icon='email' label='Email' type='email')
      v-text-field(v-model='model.password' light prepend-icon='lock' label='Senha' type='password')
      //- v-checkbox(v-model='options.shouldStayLoggedIn' light label='Permaneça logado?' hide-details)
      v-btn(block color='success' type='submit' :loading='loading') Entrar
</template>

<script>
import { auth } from '@/store/firebase'

export default {
  watch: {
    'model.email'() {
      this.error = false
    },
    'model.password'() {
      this.error = false
    }
  },

  data() {
    return {
      options: {
        shouldStayLoggedIn: true
      },
      model: {
        email: '',
        password: ''
      },
      loading: false,
      valid: true,
      error: false
    }
  },

  methods: {
    onSubmit() {
      if (!this.valid) return

      this.loading = true
      this.error = false
      const { email, password } = this.model
      auth.signInWithEmailAndPassword(email, password)
        .then((res) => {
          this.$router.push('/')
        })
        .catch((err) => {
          console.log(err)
          this.error = true
          this.alertError(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    alertError(err) {
      const { code } = err

      if (code === 'auth/user-not-found') this.$snotify.error('Não foi encontrado nenhum usuário com este email')
      else if (code === 'auth/wrong-password') this.$snotify.error('Email ou senha incorreto')
      else if (code === 'auth/user-disabled') this.$snotify.error('Usuário bloqueado, procure o administrador')
      else this.$snotify.error('Ops! Ocorreu um erro')
    }
  }
}
</script>
